
  import { defineComponent, PropType } from 'vue';
  import { mapGetters } from 'vuex';

  import { getBasePeriodsInfo } from '@/modules/ved/utils/base-info/periods';
  import { parseYearMonth } from '@/modules/ved/utils/options';

  import { VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import { getBaseTreeInfo } from '../../utils/base-info/tree';
  import BaseInfo from '../common/base-info/BaseInfo.vue';
  import { TBaseInfoItem } from '../common/base-info/types';

  export default defineComponent({
    name: 'AnalyticsNotesBaseInfo',
    components: {
      BaseInfo,
    },
    props: {
      filter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
      }),
      getItems(): TBaseInfoItem[] {
        return [this.getPeriodsItem, this.getCountriesItem, this.getSourceItem];
      },
      getPeriodsItem(): TBaseInfoItem {
        const periodsArray = Array.isArray(this.filter?.periods) ? this.filter.periods : [];
        let label = getBasePeriodsInfo(periodsArray);

        if (this.isMonthly) {
          const firstPeriod = periodsArray[0] ?? '';
          const parsed = parseYearMonth(String(firstPeriod));
          const endYear = Number(parsed.year);
          if (Number.isFinite(endYear) && endYear > 0) {
            const startYear = endYear - 8;
            label = `${startYear} - ${endYear} гг.`;
          }
        }

        return {
          label: 'Период',
          value: label,
          isLoading: false,
        };
      },
      getCountriesItem(): TBaseInfoItem {
        return {
          label: 'Страна',
          value: getBaseTreeInfo(this.getCountriesTree, this.filter.country),
          isLoading: !this.getCountriesTree.length,
        };
      },
      getSourceItem(): TBaseInfoItem {
        return {
          label: 'Источник',
          value: 'Федеральная таможенная служба',
          isLoading: false,
        };
      },
    },
  });
